const _ = require('lodash');
import storeHelpers from '@/utils/storeHelpers.js';
import utils from '@/utils/utils.js';
import analytics from "@/utils/analytics.js";

const funcs = {
    hlColors: {
      "0": { index: 0, hex: '#000000', rgb: '0,0,0' }, // clear
      "1": { index: 1, hex: '#ff0000', rgb: '255,0,0'}, // red
      "2": { index: 2, hex: '#00f27a', rgb: '0,242,122'}, // green
      "3": { index: 3, hex: '#00adff', rgb: '0,173,255'}, // blue
      "4": { index: 4, hex: '#aaff00', rgb: '170,255,0'}, // yellow
      "5": { index: 5, hex: '#f100f9', rgb: '241,0,249'}, // purple
      "6": { index: 6, hex: '#181818', rgb: '24,24,24'}, // black
      "7": { index: 7, hex: '#abd2fe', rgb: '171,210,254'} // selection
    },
    getHLPenColors: function(mode) {
      var colors = [
        { 
          baseClass: 'red',
          hlClass: 'itsi-hl-rd'
        },
        {   
          baseClass: 'green',
          hlClass: 'itsi-hl-gr'
        },
        {
          baseClass: 'blue',
          hlClass: 'itsi-hl-bl'
        },
        {
          baseClass: 'yellow',
          hlClass: 'itsi-hl-yl'
        },
        {
          baseClass: 'purple',
          hlClass: 'itsi-hl-pp'
        },
        {
          baseClass: 'black',
          hlClass: 'itsi-hl-bk' 
        }
      ]
      if (mode != "pen") {
        colors.unshift({ // eraser
          baseClass: 'none',
          hlClass: 'none'
        })
      }
      return colors
    },
    hlIndexToColor(index) {
      return funcs.hlColors[index].hex;
    },
    colorToHlIndex(r,g,b) {
      const rgbString = r + ","+ g + "," + b;
      
      const hlColor = _.find(funcs.hlColors, color => {
        return color.rgb === rgbString;
      });

      return hlColor.index;
    },
    getOrCreateAttachment: function(handle, attachmentId, contextMenuOptions, category) {
        var attachment;

        if(attachmentId !== 'new') {
            attachment = storeHelpers.getAttachmentById(handle, attachmentId)
            if(!attachment.resourceObj) {
              attachment.resourceObj = storeHelpers.getResourceById(handle, attachment.resource)
            }
          } else {
            attachment = {
              book: contextMenuOptions.bookId,
              selector: contextMenuOptions.selector,
              section: contextMenuOptions.section,
              _id: "attachment-" + utils.GUID(),
              type: "wmgc.mobi.content.resources.CssSelectorAttachment",
              resourceObj: {
                _id: "note-anotation-" + utils.GUID(),
                type: category === 'note' ? "wmgc.mobi.content.resources.NoteAnnotation" : "wmgc.mobi.content.resources.SketchAnnotation",
                category: category,
                title: category === 'note' ? "New Note" : "Freehand",
                base64text: "",
                tempText: ""
              }
            }
        }

        return attachment;
    },
    deleteAnnotation: function(handle, attachment) {
      if(attachment.resourceObj) {
        storeHelpers.addItemToSync(handle, {
          url: handle.$config.get('ecApi') + "annotations/" + attachment.resourceObj._id, 
          method: "delete",
          data: {}
        });
        analytics.annotation(handle,  attachment._id, 3);
        storeHelpers.removeResourceAndItsAttachments(handle, attachment.resourceObj);
      }
    },
    upsertAnnotation: function(handle, attachmentId, attachment, resource) {
      var newAnnotation = attachmentId === 'new';
        // if it is new add it to the store
      if(newAnnotation) {
        storeHelpers.addResource(handle, resource);
        storeHelpers.addAttachment(handle, attachment);
        analytics.annotation(handle, attachment._id, 1);
      }

      // prep data for server
      attachment.resource = attachment.resourceObj._id;
      attachment.id = attachment._id;

      var attachmentToSend = Object.assign({}, attachment);

      delete attachmentToSend.resourceObj;
      delete attachmentToSend.resource;

      storeHelpers.addItemToSync(handle, {
        url: handle.$config.get('ecApi') + "annotations/", 
        method: "post",
        data: {
          "book": attachmentToSend.book,
          "formatversion": 2,
          "id": resource._id,
          "data": JSON.stringify({
            "id": resource._id, 
            "type": resource.category === 'note' ? "wmgc.mobi.content.resources.NoteAnnotation" : "wmgc.mobi.content.resources.SketchAnnotation",
            "attachments": [
              attachmentToSend
            ],
            "title": resource.title,
            "base64text": resource.base64text,
            "packed": resource.packed
          })
        }
      });
      if (!newAnnotation)
        analytics.annotation(handle, attachment._id, 2);
    }
}

export default funcs;
